import { List } from 'immutable'

export function getElements(blockData: Core.Block['data']) {
  return [
    blockData.headline,
    ...blockData.columns.flatMap((col: Core.Plugin | Record<string, Core.Plugin>) => {
      // normal multi-column block data structure
      // (e.g. .type="multi-column", .data.columns[].type="epages.image"),
      if (col.type) return [col]

      // "plugin with text below" block data structure
      // (e.g. .type="image-with-text", .data.columns[].image.type="epages.image", .data.columns[].text.type="epages.text")
      return Object.entries(col)
        .filter(omitId)
        .sort(putTextLast)
        .map(([, value]) => value)
    }),
  ].filter(Boolean)
}

export function getPluginTypes(columns: ImmutableList) {
  return columns
    .flatMap((col: ImmutableMap) => {
      if (col.get('type') === 'nested-headline-block') return List(getPluginTypes(col.getIn(['data', 'columns'])))
      return [col.get('type')]
    })
    .toArray()
}

const putTextLast = ([key]: [string, any]) => (key === 'text' ? 1 : -1)
const omitId = ([key]: [string, any]) => key !== '_id'
